import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { SetTutorProfile, LoadTutorProfileSuccess, SetTutorProfileSuccess, GetIfAllowedToEditTutor, GetIfAllowedToEditTutorSuccess, GetIfAllowedToEditTutorError, UpdateTutor, UpdateTutorSuccess, UpdateTutorError } from "./tutor-edit.actions";
import { TutorService } from "src/app/_services/tutor.service";

@Injectable()
export class TutorEditEffects {
  constructor(
    private action$: Actions,
    private tutorService: TutorService,
    private userProfileService: UserProfileService
  ) {}
    
  public setTutorProfileEffect$ = createEffect(() => 
    this.action$.pipe(
      ofType(SetTutorProfile),
      switchMap((payload) => 
        this.userProfileService.getUserProfile$(payload?.tutorProfile?.userProfileId).pipe(
          map((result: Userprofile) => {
            return LoadTutorProfileSuccess({userProfile: result});
          })
        )
      )
    )
  );

  public setLoadTutorProfileEffect$ =  createEffect(() =>
    this.action$.pipe( 
      ofType(LoadTutorProfileSuccess),
      map(() => {
        return SetTutorProfileSuccess();
      })
    ),
  );

  public getCheckIfAllowedToEditTutorEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetIfAllowedToEditTutor),
      switchMap((payload) =>
        this.tutorService.isCurrentUserAllowedToEditTutor$(payload.selectedTutorId).pipe(
          map((result: boolean) => {
            return GetIfAllowedToEditTutorSuccess({ result: result });
          }),
          catchError((error: any) => {
            return of(GetIfAllowedToEditTutorError({ error: error }));
          })
        )
      )
    )
  );

  public updateTutorEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(UpdateTutor),
      switchMap((payload) =>
        this.tutorService.updateTutor$(payload.updateTutorDto).pipe(
          map((result: Userprofile) => {
            return UpdateTutorSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UpdateTutorError({ updateTutorError: error }));
          })
        )
      )
    )
  );
}